export default __webpack_public_path__ + "static/media/plan_question_type.95d1e986.png";